import { useEffect, useMemo } from 'react'
import { AudioContextFactory } from '../contexts/AudioContextFactory'

export function useAudioPlayerGain(mute: boolean, volume: number) {
  const gainNode = useMemo(() => {
    const gainNode = AudioContextFactory.getAudioContext().createGain()
    gainNode.gain.value = 0
    gainNode.connect(AudioContextFactory.getAudioContext().destination)
    return gainNode
  }, [])

  useEffect(() => {
    gainNode.gain.value = mute ? 0 : volume
  }, [gainNode, volume, mute])

  return gainNode
}
